module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/sp/hospital_detail/img_online_module-c18c261ee5d30b4847ab15d890c5f884.png";